// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconBackTop: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
            <g fill="none" fillRule="evenodd">
                <rect width="36" height="36" fill="currentColor" rx="18" />
                <polygon
                    fill="#FFF"
                    fillRule="nonzero"
                    points="8.395 .918 7.5 0 6.605 .918 .899 6.738 0 7.652 1.795 9.479 2.69 8.565 6.232 4.952 6.232 16.706 6.232 18 8.768 18 8.768 16.706 8.768 4.952 12.31 8.565 13.205 9.479 15 7.652 14.105 6.738 8.399 .918"
                    transform="translate(10.5 9)"
                />
            </g>
        </svg>
    );
};

export default React.memo(IconBackTop);
